import React, { useState } from 'react';
import Link from 'atomic/link';
import { items } from './data/footer.data';
import Icon from 'atomic/icon';
import ras_logo from '../../../assets/images/ras_logo.svg';
import Accordion from 'modules/shared/components/accordion/accordion';

import './footer.mobile.scss';

const FooterMobile: React.FC = () => {
    const [activeTab, setActiveTab] = useState<number | null>(0);
    const handleToggle = (index: number): void => setActiveTab(index === activeTab ? null : index);

    return (
        <footer className="footer">
            <div className="footer__main" data-section="footer-main">
                <ul className="accordion--footer">
                    {
                        items.map((item, index: number) => (
                            <Accordion
                                key={index}
                                activeTab={activeTab}
                                label={item.label}
                                handleToggle={handleToggle}
                                index={index}
                            >
                                <ul>
                                    {
                                        item.items.map(link => (
                                            <li key={link.href}>
                                                <Link
                                                    color="flat"
                                                    href={link.href}
                                                    rel={link.rel}
                                                    target={link.target}
                                                    title={link.title}
                                                    weight={link.weight ?? '400'}
                                                    block={true}
                                                >
                                                    {link.icon && (
                                                        <Icon
                                                            name={link.icon}
                                                            color="dark"
                                                            size={18}
                                                        />
                                                    )}
                                                    <span>{link.label}</span>
                                                </Link>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </Accordion>
                        ))
                    }
                </ul>
            </div>
            <div className="footer__aside" data-section="footer-aside">
                <p>
                    Należymy do
                </p>
                <div className="footer__aside__image">
                    <img
                        src={ras_logo}
                        width={100}
                        height={41}
                        alt="RASP"
                    />
                </div>
            </div>
        </footer>
    );
};

export default FooterMobile;
